module.exports = __webpack_public_path__ + "img/xmas_feature_h.bc060198.png";